import "./testimonials.css"; // Custom styling

import {
  MDBCard,
  MDBCardBody,
  MDBCarousel,
  MDBCarouselItem,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
} from "mdb-react-ui-kit";

import React from "react";
import { assest } from "../../assest/assest";

// Define an array of testimonials
const testimonials = [
  {
    id: 2,
    name: "Mr. Kasun Kalhara",
    role: "Music Artist",
    quote: "Choosing the right mentor is challenging, as not every mentor relationship is successful. Some can even hinder an artist’s growth.",
    imageUrl: assest.kasun,
  },
  {
    id: 1,
    name: "Mr. Deepal Sooriyaarachchi",
    role: "Director of AIA Insurance Sri Lanka",
    quote: "You can be successful today, but if your success lacks integrity, it won’t be fulfilling in the long run.",
    imageUrl: assest.dipa
  },
  {
    id: 3,
    name: "Dr. Nadeesha Chandrasena",
    role: "Business Analyst, Smart Cities and Product Manager",
    quote: "Dreaming is important, but it’s not enough on its own.",
    imageUrl: assest.nadi
  },
  {
    id: 4,
    name: "Mrs. Sandra Wanduragala",
    role: "Founder & Chairwomen of SEYLIN Exports (Pvt.)Ltd",
    quote: "If you want to step out and take on challenges, it requires stepping out of your comfort zone.",
    imageUrl: assest.san
  },
  {
    id: 5,
    name: "Mr. Dilupa Pathirana",
    role: "Chief Executive Officer in Barista Coffee Lanka(Pvt) Ltd",
    quote: "starting from the bottom and working your way up is crucial. It allows you to gain experience in all aspects of the job.",
    imageUrl: assest.dilu
  },
  {
    id: 6,
    name: "Mr. Dilshan Abeygunawardana",
    role: "Entrepreneur,Content Creator",
    quote: "Success isn’t about having a large team but about having the right team.",
    imageUrl: assest.dila
  },
  // Add more testimonials here as needed
];

const Testimonials = () => {
  return (
    <div className="xx" id="memories">
      <MDBContainer fluid className="py-5 px-4 gradient-custom">
        <MDBRow className="d-flex justify-content-center">
          <MDBCol md="12">
            {/* Testimonials Heading */}
            <div className="text-center mb-4">
              <h2 className="testimonials-title">Testimonials</h2>
            </div>

            <div className="text-center mb-4 pb-2">
              <MDBIcon fas icon="quote-left" size="3x" className="text-white" />
            </div>

            <MDBCard className="card-a">
              <MDBCardBody style={{ backgroundColor: 'black', borderRadius: '15px' }} className="px-4 py-5">
                <MDBCarousel showIndicators fade>
                  {/* Map through the testimonials array */}
                  {testimonials.map((testimonial) => (
                    <MDBCarouselItem key={testimonial.id}>
                      <MDBRow className="d-flex justify-content-center">
                        <MDBCol lg="10" xl="8">
                          <MDBRow>
                            <MDBCol lg="4" className="d-flex justify-content-center">
                              <img
                                src={testimonial.imageUrl}
                                className="square-image shadow-1 mb-4"
                                alt={testimonial.name}
                                width="200"
                                height="200"
                              />
                            </MDBCol>
                            <MDBCol md="9" lg="7" xl="8" className="text-center text-lg-start mx-auto">
                              <div className="testimonial-text">
                                <MDBIcon fas icon="quote-left" size="2x" className="text-white" />
                                <h4 style={{ color: 'white' }} className="mb-4">{testimonial.name}</h4>
                                {/* Role styled and centered under the name */}
                                <h5 style={{ fontSize: '1.1rem', color: '#ac834f', fontWeight: 'normal', marginBottom: '20px' }} className="text-center">{testimonial.role}</h5>
                                <p style={{ color: 'white' }} className="mb-0 pb-3">
                                  "{testimonial.quote}"
                                </p>
                                <MDBIcon fas icon="quote-right" size="2x" className="text-white" />
                              </div>
                            </MDBCol>
                          </MDBRow>
                        </MDBCol>
                      </MDBRow>
                    </MDBCarouselItem>
                  ))}
                </MDBCarousel>
              </MDBCardBody>
            </MDBCard>

            <div className="text-center mt-4 pt-2">
              <MDBIcon fas icon="quote-right" size="3x" className="text-white" />
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};

export default Testimonials;
